import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const LegendContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(1),
  '@media (max-width: 550px)': {
    justifyContent: 'flex-start',
    gap: theme.spacing(1),
  },
  '&.space-between': {
    justifyContent: 'space-between',
    '@media (max-width: 500px)': {
      flexDirection: 'column',
    },
  },
}));

export const ColorDot = styled(Box)<{ color: string; size: number }>(({ theme, color, size }) => ({
  backgroundColor: color,
  height: size,
  width: size,
  borderRadius: '50%',
  marginRight: theme.spacing(1),
}));
